import React from 'react'

const GroceryOrderdetails = () => {
    return (
        <div>

        </div>
    )
}

export default GroceryOrderdetails
